import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { FormControlLabel } from "material-ui/Form";
import Switch from "material-ui/Switch";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { createMuiTheme } from 'material-ui/styles';

const theme = createMuiTheme({
  overrides: {
    MuiSwitch: {
      checked: {
        '& + $bar': {
          backgroundColor: "#FFFFFF !important", // importantがないとデフォルトの値で上書きされてしまうのでつける
        },
      },
      icon: {
        backgroundColor: "#FFFFFF",
      },
    },
  },
});

const styles = () => ({
  root: {
    position: "relative",
  },

  container: {
    width: "100%",
    height: "45px",
    border: "1px solid #1A65FF",
    borderRadius: "100px",
    opacity: "1",
    display: "flex",
    alignItems: "center",
  },

  label: {
    fontSize: "13px",
    fontWeight: "bold",
    paddingLeft: "17px",
  },

  // トグルはスクロール中に表示が消えなくバグがあるため、position: absolute; で表示させ、ツールチップの表示ホバー外とする
  toggleContainer: {
    position: "absolute",
    top: "-2px",
    right: "3px",
  },

  toggle: {
    margin: 0,
  },
});

class CallAnalysisControl extends React.Component {
  initialState = {
    checked: true,
  }

  constructor(props) {
    super(props);
    this.state = { ...this.initialState };
  }

  componentWillMount() {
    this.setState({
      checked: this.props.checked,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.checked !== nextProps.checked) {
      this.setState({
        checked: nextProps.checked,
      });
    }
  }

  handleCheck = (e) => {
    this.setState({
      checked: e.target.checked,
    });

    this.props.handleCheck();
  }

  render() {
    const { classes, disabled } = this.props;

    return (
      <div style={this.props.style} className={classes.root}>
        <div className={classes.container} style={{ backgroundColor: this.state.checked ? '#1A65FF' : '#F2F6FF' }} >
          <div className={classes.label} style={{ color: this.state.checked ? '#FFFFFF' : '#1A65FF' }}>コール分析あり</div>
        </div>
        <div className={classes.toggleContainer}>
        <MuiThemeProvider theme={theme}>
            <FormControlLabel
              control={
                  <Switch
                    checked={this.state.checked}
                    onChange={this.handleCheck}
                    value="call_analysis_filter"
                    disabled={disabled}
                  />
                }
                className={classes.toggle}
              />
          </MuiThemeProvider>
        </div>
        {this.props.children}
      </div>
    )
  }
}

CallAnalysisControl.propTypes = {
  classes: PropTypes.object.isRequired,
  style: PropTypes.object,
  user: PropTypes.object,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  handleCheck: PropTypes.func,
  children: PropTypes.node,
};

export default withStyles(styles)(CallAnalysisControl);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/controls/CallAnalysisControl.jsx